module.exports = __webpack_public_path__ + "static/media/location.bb2ade6d.png";